import type { DashboardSection } from '@/components/dashboard/DashboardSidebar';

export interface FeatureFlag {
  id: string;
  flag_key: string;
  enabled: boolean;
  label: string;
  description: string | null;
  category: string;
  updated_by: string | null;
  updated_at: string;
  created_at: string;
}

// REK-2186: social SSO kill-switch / order — boolean `enabled` + optional JSON
// in `description` (`{order,disabled}`). No JSON column on this table.
export {
  AUTH_SOCIAL_PROVIDERS_FLAG_KEY,
  AUTH_SOCIAL_PROVIDERS_FLAG_CATEGORY,
  parseSocialProvidersFlagDescription,
  applySocialProvidersFlag,
  type SocialProvidersFlagConfig,
} from '@/lib/socialProvidersFlag';

// Map flag keys to dashboard section IDs
export const FLAG_TO_SECTION: Record<string, DashboardSection> = {
  'dashboard.overview': 'overview',
  'dashboard.pool': 'pool',
  'dashboard.surveys': 'surveys',
  'dashboard.predictions': 'predictions',
  'dashboard.referrals': 'referrals',
  'dashboard.wallet': 'wallet',
  'dashboard.my-data': 'my-data',
  'dashboard.messages': 'messages',
  'dashboard.redeem': 'redeem',
  'dashboard.breaches': 'breaches',
  'dashboard.brand-access': 'brand-access',
};

export const SECTION_TO_FLAG: Record<DashboardSection, string> = {
  'overview': 'dashboard.overview',
  'pool': 'dashboard.pool',
  'surveys': 'dashboard.surveys',
  'predictions': 'dashboard.predictions',
  'referrals': 'dashboard.referrals',
  'wallet': 'dashboard.wallet',
  'my-data': 'dashboard.my-data',
  'messages': 'dashboard.messages',
  'redeem': 'dashboard.redeem',
  'breaches': 'dashboard.breaches',
  'brand-access': 'dashboard.brand-access',
};

// Fallback defaults if database is unavailable
export const DEFAULT_ENABLED_SECTIONS: DashboardSection[] = [
  'overview',
  'pool',
  'surveys',
  'referrals',
  'wallet',
  'my-data',
  'brand-access',
];
